// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Equalizer from "@material-ui/icons/Equalizer";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import MenuItem from "@material-ui/core/MenuItem";

// services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioSaldoEstoque() {
    const { t } = useTranslation();

    useEffect(() => {
        LoadSelectProduto();
        verifyAcess();
        sendScrollToTOP();
    }, []);

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);

    const LoadEstabelecimentos = () =>{
        setloadingSelectEstabelecimentos(true);   
        let endPointE = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPointE).then(result=>{      
            if(result.status !== 200)
            {                                     
                showNotification(t('error_message.could_not_load_establishments')+"!",'danger'); 
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setlistSelectEstabelecimentos(result.data);  
            setloadingSelectEstabelecimentos(false); 
            return true;                
        });  
    }

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setlistSelectEstabelecimentosSelected([{estabelecimentoId:session.estabelecimentoId}]);
            setshowSelectEstabelecimentos(false)
        }
    }

    const [situacaoItem, setSituacaoItem] = React.useState("Todos");
    const optionsSituacao = [
        { value: 'Todos', label: 'Todos' },
        { value: 'Com saldo', label: 'Com saldo' },
        { value: 'Sem saldo', label: 'Sem saldo' }
    ];
    const handleSituacaoChange = (value) => {
        setSituacaoItem(value);
    }
    
    const [produtoItem, setProdutoItem] = React.useState("0");
    const [listSelectProduto, setListSelectProduto] = React.useState([]);
    
    const handleProdutoChange = event => {
        setProdutoItem(event.target.value);
        setValue("expediente", event.target.value);
        if (event.target.value !== "")
            clearError("expediente");
    };

    const LoadSelectProduto = () => {
        const endPoint = "Produtos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            setListSelectProduto(result.data);
            return true;
        });
    }

    const handleClickPesquisa = () => {
        let obj = {
            estabelecimentoId: session.estabelecimentoId, 
            produtoId: produtoItem,
            situacao: situacaoItem,
        }

        loadDados(obj);
    }

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) => {
        setisLoadingList(true);
        const endPoint = "relatorios/relatorioSaldoEstoque/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);
            return true;
        });
    }

    const columnsProp = [
        {
            Header: t('label.group'),
            filterable: false,
            accessor: "grupoProduto",
            width: 180,
        },
        {
            Header: t('label.product'),
            filterable: false,
            accessor: "descricaoProduto",
            width: 180,
        },
        {
            Header: t('information_message.current_balance'),
            filterable: false,
            accessor: "saldoProduto",
            width: 150,
        },
        {
            Header: t('label.active'),
            filterable: false,
            accessor: "ativo",
            width: 150,
        },
        {
            Header: t('information_message.does_the_product_control_stock'),
            filterable: false,
            accessor: "controlaEstoque",
            width: 250,
        },
        {
            Header: t('information_message.is_the_product_blocked_for_sale'),
            filterable: false,
            accessor: "bloqueadoVenda",
            width: 300,
        },
    ];
    const columns = [...columnsProp];
    const [dataCSV, setdataCSV] = React.useState([]);
    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimentoDescricao" },
        { displayName: "Grupo", id: "grupoProduto" },
        { displayName: "Produto", id: "descricaoProduto" },
        { displayName: "Saldo Atual", id: "saldoProduto" },
        { displayName: "Ativo", id: "ativo" },
        { displayName: "Controle estoque", id: "controlaEstoque" },
        { displayName: "Bloqueado para venda", id: "bloqueadoVenda" },
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];
        
        data.map(item =>{
            var obj = {
                estabelecimentoDescricao: item.estabelecimentoDescricao,
                grupoProduto: item.grupoProduto,
                descricaoProduto: item.descricaoProduto,
                saldoProduto: item.saldoProduto,
                ativo: item.ativo,
                controlaEstoque: item.controlaEstoque,
                bloqueadoVenda: item.bloqueadoVenda,
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    }

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    }
    
    const classes = useStyles();
    return (
        <>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.stock_balance')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>

                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                            {
                                                t('label.situation')
                                            } 
                                        </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.situacaoItem ? true : false)}
                                            isSearchable={true}
                                            name="Situacao"
                                            options={optionsSituacao}
                                            value={optionsSituacao.filter(({value}) => value === situacaoItem)}
                                            onChange={(option) => handleSituacaoChange(option.value !== null ? option.value : "Todos") }
                                            placeholder="Todos"
                                            ref={() => register({ name: "Situacao" })}
                                        />
                                        {
                                            errors.situacaoItem && 
                                            <FormHelperText className={classes.labelRootError}>
                                                <span> {errors.situacaoItem.message} </span>
                                            </FormHelperText>
                                        } 
                                    </FormControl>
                                </GridItem>

                                <GridItem xs={12} sm={6} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.produtoItem ? true : false}
                                            select
                                            variant="outlined"
                                            label={t('register.product')}
                                            value={produtoItem}
                                            onChange={handleProdutoChange}
                                            name="produto"
                                            InputLabelProps={{ shrink: true }}
                                        >
                                            <MenuItem value="0">
                                                <em>Todos</em>
                                            </MenuItem>
                                            {listSelectProduto.map(item => (
                                                <MenuItem key={item.produtoId}
                                                    classes={{
                                                        root: classes.selectMenuItem,
                                                        selected: classes.selectMenuItemSelected
                                                    }}
                                                    value={item.produtoId}
                                                >
                                                    {item.descricao}
                                                </MenuItem>
                                                ))
                                            }
                                        </TextField>
                                        {
                                            errors.produtoItem && 
                                            <FormHelperText className={classes.labelRootError}>
                                                <span> {errors.produtoItem.message} </span>                                                                          
                                            </FormHelperText>
                                        }
                                    </FormControl> 
                                </GridItem>

                                <GridItem xs={12} sm={6} md={2}>
                                    <Button  round color="primary" 
                                        onClick={e => { handleClickPesquisa()}}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>

                            </GridContainer>
                            {
                                dataCSV.length > 0 &&
                                <div>
                                    <div style={{float:'right'}}>
                                    <CsvDownloader
                                        filename="Relatório Saldo Estoque"
                                        columns={columnsCSV}
                                        datas={dataCSV}
                                        separator={";"}>
                                        <Button  round color="default" size="sm" >
                                            CSV
                                        </Button> 
                                    </CsvDownloader>
                                    </div><div style={{clear:'both'}}></div>
                                </div>
                            }
                            <div style={{overflow:'auto',width:'100%'}}>
                                <div style={{minWidth:'1000px'}}> 
                                    {/*  */}
                                    <ReactTable                  
                                        loading = {isLoadingList}
                                        data={list}
                                        filterable
                                        defaultFilterMethod = {noCaseSensitive}
                                        columns={columns}
                                        style={{height: "400px"}}
                                        showPagination={false}
                                        pageSize={list.length}
                                        minRows={5}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading')+"..."}
                                        noDataText={t('information_message.no_records_found')+"!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </>
    );
}